/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EditionCustomizationIconRequest } from './editionCustomizationIconRequest';

export interface EditionCustomizationRequest {
  businessUnitId?: number;
  editionCardBackgroundColor?: string;
  editionCardDesktop?: string;
  editionCardMobile?: string;
  editionDate?: number;
  editionTheme?: string;
  icons?: Array<EditionCustomizationIconRequest>;
  lastEditionsCarouselCard?: string;
  lastEditionsCarouselCardAlt?: string;
}
